export default {
    outcome_1: 'Non-hospitalized',
    outcome_2: 'Hospitalized',
    outcome_3: 'Death',
    outcome_4: 'Any',
};
